import { render, staticRenderFns } from "./PoliticasSeguridad.vue?vue&type=template&id=17a9821f"
import script from "./PoliticasSeguridad.vue?vue&type=script&lang=js"
export * from "./PoliticasSeguridad.vue?vue&type=script&lang=js"
import style0 from "./PoliticasSeguridad.vue?vue&type=style&index=0&id=17a9821f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports